import React, { useState } from "react";
import PerfEvalEMPHODTable from "./PerfEvalEMPHODTable.jsx";
import { RingLoader } from "react-spinners";
import { css } from "@emotion/react";

const override = css`
  display: block;
  margin: 0 auto;
  margin-top: 45px;
  border-color: red;
`;
export default function PerfEvalEMPHOD(props) {
  const [loading, setLoading] = useState(false);

  return (
    <React.Fragment>
      {!loading ? (
        <PerfEvalEMPHODTable data={props.data} />
      ) : (
        <div id="loading-bar">
          <RingLoader
            css={override}
            sizeUnit={"px"}
            size={50}
            color={"#0000ff"}
            loading={true}
          />
        </div>
      )}
    </React.Fragment>
  );
}
